var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWelcome = function SvgWelcome(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 196 196",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.878.312h.229c53.915 0 97.621 43.797 97.621 97.825 0 54.027-43.706 97.824-97.621 97.824h-.457c-53.915 0-97.622-43.797-97.622-97.824C.028 44.109 43.735.312 97.65.312h.228z",
    fill: "#612551",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.878 22.056h.178c41.931 0 75.923 34.062 75.923 76.08 0 42.019-33.992 76.081-75.923 76.081h-.355c-41.931 0-75.923-34.062-75.923-76.08 0-42.019 33.992-76.081 75.923-76.081h.177z",
    fill: "#612551",
    fillOpacity: 0.61
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.105 105.01s6.212 8.824 11.386 46.895a15.34 15.34 0 01-8.191 15.717l-6.773 3.471-10.493-50.811 14.071-15.272zM62.895 105.01s-6.212 8.824-11.386 46.895a15.34 15.34 0 008.191 15.717l6.773 3.471 10.493-50.811-14.071-15.272z",
    fill: "#FFFFFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98 93.439l35.105 11.572s-6.163 35.786-7.385 66.082H70.28c-1.223-30.296-7.386-66.082-7.386-66.082L98 93.439z",
    fill: "#DD526D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.876 110.398l-3.113 19.224L98 144.213l-10.764-14.591-3.112-19.224h27.752z",
    fill: "#EBE2EA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98 144.213s8.532-20.599 6.847-40.214l5.863-7.648s15.769 22.971-12.71 47.862zM98 144.213s-8.532-20.599-6.847-40.214l-5.863-7.648S69.52 119.322 98 144.213z",
    fill: "#E57489"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98 110.398c7.933 4.368 12.149 11.083 14.329 16.175.446 1.042 1.52 1.37 2.406 1.087a1.907 1.907 0 001.321-1.548c1.461-8.957 2.549-23.524-4.113-30.148-3.293-3.275-10.037-7.97-13.943-8.323-3.906.352-10.65 5.048-13.943 8.322-6.662 6.625-5.574 21.192-4.113 30.149a1.906 1.906 0 001.32 1.548c.887.283 1.961-.045 2.407-1.087 2.18-5.092 6.396-11.807 14.329-16.175z",
    fill: "#FFFFFE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98 110.398c8.221-5.404 10.763-13.422 10.763-13.422l-3.384-11.102H90.621l-3.385 11.102S89.78 104.994 98 110.398z",
    fill: "#DFB46C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98 35.884c16.314 0 28.958 11.309 28.958 30.43 0 20.276-10.02 25.709-13.894 27.412 0 0-3.593-7.852-15.064-7.852-11.472 0-15.064 7.852-15.064 7.852-3.874-1.703-13.894-7.136-13.894-27.412 0-19.121 12.644-30.43 28.958-30.43z",
    fill: "#335"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98 95.109c9.715 0 21.034-15.47 21.034-32.698 0-17.35-10.808-23-21.034-23-10.226 0-21.034 5.65-21.034 23 0 17.228 11.319 32.698 21.034 32.698z",
    fill: "#F9CF83"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.743 68.753s23.31-1.55 30.042-13.301c0 0 4.962 15.187 15.29 17.74l2.548-14.38-6.438-14.918-15.96-6.182-12.989 1.698-10.884 8.516-3.218 9.676 1.61 11.15z",
    fill: "#335"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.883 136.613c.921 0 1.738.415 2.321 1.072.701.789 1.063 1.927.86 3.114l-5.356 31.263a2.581 2.581 0 01-.605 1.272 2.583 2.583 0 01-1.946.884H66.843a2.585 2.585 0 01-2.551-2.156l-5.356-31.263c-.203-1.187.159-2.325.86-3.114.582-.657 1.4-1.072 2.32-1.072h71.767z",
    fill: "#5EC3DE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.883 138.859c.921 0 1.738.415 2.321 1.072.35.394.615.875.768 1.405l.092-.537c.203-1.187-.159-2.325-.86-3.114-.583-.657-1.4-1.072-2.321-1.072H62.116c-.92 0-1.738.415-2.32 1.072-.701.789-1.063 1.927-.86 3.114l.092.537c.153-.53.418-1.011.767-1.405.583-.657 1.401-1.072 2.322-1.072h71.766zM98 151.109c3.985 0 7.215 2.583 7.215 5.77 0 3.187-3.23 5.77-7.215 5.77s-7.215-2.583-7.215-5.77c0-3.187 3.23-5.77 7.215-5.77z",
    fill: "#96D3E3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.06 80.417l.702-.197c2.034 7.29 7.647 9.164 10.585 9.644a.881.881 0 01.842-.424l1.58.161a.886.886 0 01-.18 1.76l-1.579-.162a.885.885 0 01-.757-.635c-3.11-.538-9.075-2.559-11.193-10.147z",
    fill: "#5EC3DE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.399 75.678c-.72-4.043.344-7.614 2.377-7.978.083-.015.165-.023.248-.027a.84.84 0 01.442.108c.194.108.346.29.413.512a57.019 57.019 0 011.535 6.488c.419 2.35.683 4.596.8 6.62a.878.878 0 01-.27.685.844.844 0 01-.318.192c-.08.026-.16.046-.242.061-2.033.364-4.265-2.618-4.985-6.66z",
    fill: "#DD526D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.6 82.294a.889.889 0 00.272-.692 57.68 57.68 0 00-.809-6.69 57.61 57.61 0 00-1.552-6.558.884.884 0 00-.31-.444c.183-.098.373-.174.575-.21.082-.015.165-.023.248-.027a.84.84 0 01.442.108c.194.108.345.29.413.512a56.997 56.997 0 011.535 6.488c.418 2.35.683 4.596.8 6.619a.878.878 0 01-.27.686.845.845 0 01-.318.192c-.08.026-.16.046-.242.061a2.001 2.001 0 01-.806-.027c.007-.007.015-.01.022-.018z",
    fill: "#E57489"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.487 39.214c-6.007 0-10.878 4.88-10.878 10.901 0 1.123.17 2.206.485 3.226l-5.546 3.867 7.019-.857a10.856 10.856 0 008.92 4.665c6.008 0 10.878-4.88 10.878-10.901 0-6.02-4.87-10.9-10.878-10.9z",
    fill: "#FFFFFE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.751 49.11a1.005 1.005 0 000 2.01 1.005 1.005 0 000-2.01zM156.487 49.11a1.005 1.005 0 000 2.01 1.005 1.005 0 000-2.01zM161.224 49.11a1.005 1.005 0 000 2.01 1.004 1.004 0 000-2.01z",
    fill: "#916EA2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.094 116.857c-2.452 0-4.714.813-6.534 2.185l-7.017-3.367 4.205 6.504a10.865 10.865 0 00-1.532 5.578c0 6.021 4.87 10.901 10.878 10.901s10.878-4.88 10.878-10.901c0-6.02-4.87-10.9-10.878-10.9z",
    fill: "#FFFFFE"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.719 125.665l4.587 6.647 6.162-10.081-6.162 6.018-4.587-2.584z",
    fill: "#916EA2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.457 115.675l-7.284 3.494a10.818 10.818 0 00-6.696-2.312c-6.008 0-10.878 4.88-10.878 10.9 0 6.021 4.87 10.901 10.878 10.901 6.007 0 10.878-4.88 10.878-10.901a10.87 10.87 0 00-1.33-5.226l4.432-6.856z",
    fill: "#FFFFFE"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.015 131.383c0 .493-.34.846-.793.846-.455 0-.795-.353-.795-.846 0-.48.34-.822.795-.822.453 0 .793.342.793.822zm-.756-8.047c1.513 0 2.521.734 2.521 2.11 0 1.996-1.991 2.084-1.991 3.789h-1.11c0-2.033 1.753-2.046 1.753-3.575 0-.732-.517-1.086-1.299-1.086-.82 0-1.31.43-1.349 1.289l-1.134-.013c.05-1.603 1.046-2.514 2.61-2.514z",
    fill: "#916EA2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.452 57.209l-7.561-5.274c.099-.592.154-1.2.154-1.82 0-6.02-4.87-10.9-10.878-10.9s-10.878 4.88-10.878 10.9c0 6.02 4.87 10.9 10.878 10.9 3.807 0 7.155-1.961 9.099-4.93l9.186 1.123z",
    fill: "#FFFFFE"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.514 46.794h9.305v-1.019h-9.305v1.02zM32.514 50.624h9.305v-1.018h-9.305v1.018zM32.514 54.455h9.305v-1.02h-9.305v1.02z",
    fill: "#916EA2"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWelcome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/welcome.41cadd4a.svg";
export { ForwardRef as ReactComponent };